export default __webpack_public_path__ + "static/media/MariekeLovelace.0016db2d.png";